var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mem_user" }, [
    _vm.obj_to_null(this.init_user)
      ? _c(
          "div",
          { staticClass: "form-group" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("user-block", {
              key: "init_user",
              attrs: { user: _vm.init_user },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.obj_to_null(this.recipient)
      ? _c(
          "div",
          { staticClass: "form-group" },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("user-block", {
              key: "recipient",
              attrs: { user: _vm.recipient },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.obj_to_null(this.isp_user)
      ? _c(
          "div",
          { staticClass: "form-group" },
          [
            _vm._m(2),
            _vm._v(" "),
            _c("user-block", { key: "isp", attrs: { user: _vm.isp_user } }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "control-label" }, [
      _c(
        "label",
        { attrs: { id: "jform_init_user_id-lbl", for: "jform_init_user_id" } },
        [_vm._v("\n                Ініціатор\n            ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "control-label" }, [
      _c(
        "label",
        { attrs: { id: "jform_rec_user_id-lbl", for: "jform_rec_user_id" } },
        [_vm._v("\n                Затвердження\n            ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "control-label" }, [
      _c(
        "label",
        { attrs: { id: "jform_isp_user_id-lbl", for: "jform_rec_user_id" } },
        [_vm._v("\n                Виконавець\n            ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }